export const JD_UPLOAD_ERROR_CODES = {
  REQUIRED: 'project.jd.required',
  UPLOAD_FAILED: 'project.jd.upload.failed',
  GRIT_AI_SERVICE_FAILED: 'project.jd.grit.ai.service.failed',
  GRIT_AI_SUBMIT_FAILED: 'project.jd.grit.ai.submit.failed',
  GRIT_AI_ERROR: 'grit.ai.error',
  GRIT_AI_QUOTA_EXCEEDED: 'project.jd.grit.ai.quota.exceeded',
  CANDIDATE_GRIT_AI_FAILED: 'project.candidate.grit.ai.failed',
  CANDIDATE_GRIT_AI_PROMPT_FAILED: 'project.candidate.grit.ai.prompt.failed',
};

const JD_UPLOAD_ERROR_I18N_KEYS = {
  [JD_UPLOAD_ERROR_CODES.REQUIRED]: 'projectJdRequired',
  [JD_UPLOAD_ERROR_CODES.UPLOAD_FAILED]: 'projectJdUploadFailed',
  [JD_UPLOAD_ERROR_CODES.GRIT_AI_SERVICE_FAILED]:
    'projectJdGritAiServiceFailed',
  [JD_UPLOAD_ERROR_CODES.GRIT_AI_SUBMIT_FAILED]: 'projectJdGritAiSubmitFailed',
  [JD_UPLOAD_ERROR_CODES.GRIT_AI_ERROR]: 'gritAiError',
  [JD_UPLOAD_ERROR_CODES.GRIT_AI_QUOTA_EXCEEDED]:
    'projectJdGritAiQuotaExceeded',
  [JD_UPLOAD_ERROR_CODES.CANDIDATE_GRIT_AI_FAILED]: 'candidateGritAiFailed',
  [JD_UPLOAD_ERROR_CODES.CANDIDATE_GRIT_AI_PROMPT_FAILED]:
    'candidateGritAiPromptFailed',
};

const CANDIDATE_SEARCH_AI_ERROR_CODES = new Set([
  JD_UPLOAD_ERROR_CODES.CANDIDATE_GRIT_AI_FAILED,
  JD_UPLOAD_ERROR_CODES.CANDIDATE_GRIT_AI_PROMPT_FAILED,
]);

const JD_UPLOAD_TASK_ERROR_CODES = new Set([
  JD_UPLOAD_ERROR_CODES.REQUIRED,
  JD_UPLOAD_ERROR_CODES.UPLOAD_FAILED,
  JD_UPLOAD_ERROR_CODES.GRIT_AI_SERVICE_FAILED,
  JD_UPLOAD_ERROR_CODES.GRIT_AI_SUBMIT_FAILED,
  JD_UPLOAD_ERROR_CODES.GRIT_AI_QUOTA_EXCEEDED,
]);

export const resolveJdUploadErrorI18nKey = (errorCode) => {
  if (!errorCode || typeof errorCode !== 'string') {
    return null;
  }

  return JD_UPLOAD_ERROR_I18N_KEYS[errorCode] || null;
};

export const isCandidateSearchAiError = (errorCode) =>
  CANDIDATE_SEARCH_AI_ERROR_CODES.has(errorCode);

export const isJdUploadTaskError = (errorCode) =>
  JD_UPLOAD_TASK_ERROR_CODES.has(errorCode);

export const isJdServiceFailure = (errorOrTaskData) =>
  errorOrTaskData === JD_UPLOAD_ERROR_CODES.GRIT_AI_SERVICE_FAILED;

export const isTaskJdServiceFailure = (taskResponse) =>
  taskResponse?.is_failed === true &&
  taskResponse?.failure_reason === JD_UPLOAD_ERROR_CODES.GRIT_AI_SERVICE_FAILED;

export const resolveBackendJdUploadErrorCode = (message) => {
  if (!message || typeof message !== 'string') {
    return null;
  }

  if (JD_UPLOAD_ERROR_I18N_KEYS[message]) {
    return message;
  }

  if (
    message.includes('quota') ||
    message.includes('429') ||
    message.includes('limit exceeded') ||
    message.includes('exhausted')
  ) {
    return JD_UPLOAD_ERROR_CODES.GRIT_AI_QUOTA_EXCEEDED;
  }

  if (message.includes('grit.ai')) {
    return JD_UPLOAD_ERROR_CODES.GRIT_AI_ERROR;
  }

  return null;
};

export const resolveBackendAiErrorCode = (responseData) => {
  if (!responseData || typeof responseData !== 'object') {
    return null;
  }

  const messages = [
    responseData.message,
    responseData.error,
    responseData.errorMessage,
  ].filter((message) => typeof message === 'string' && message);

  for (let i = 0; i < messages.length; i += 1) {
    const message = messages[i];

    if (JD_UPLOAD_ERROR_I18N_KEYS[message]) {
      return message;
    }

    const resolvedCode = resolveBackendJdUploadErrorCode(message);
    if (resolvedCode) {
      return resolvedCode;
    }
  }

  return null;
};
